document.addEventListener("DOMContentLoaded", function () {
  let spare = document.querySelector(".altomayo-variant-spare-price");

  function checkSecondVariant() {
    if (spare) {
      let variants = document.querySelectorAll(
        ".variant-picker__option-values .altomayo-image-variant input"
      );
      if (variants.length > 1 && variants[1].checked) {
        // Check if the second variant exists and is checked
        spare.style.display = "block";
      } else {
        spare.style.display = "none";
      }
    }
  }

  // Initial check on page load
  checkSecondVariant();

  // Event delegation to handle dynamic content
  if (document.querySelector(".variant-picker__option-values")) {
    document
      .querySelector(".variant-picker__option-values")
      .addEventListener("change", function (e) {
        if (e.target.matches(".altomayo-image-variant input")) {
          checkSecondVariant();
        }
      });
  }

  // Fallback check every 500ms to ensure correct state
  setInterval(checkSecondVariant, 500);
});

window.addEventListener("load", function () {
  let ratingStars = document.querySelectorAll(
    '.product-info__block-item .ruk_rating_snippet i[aria-hidden="true"]'
  );
  let ratingWidget = document.querySelector(
    ".shopify-section #reviewsio-carousel-widget"
  );
  let headerHeight = 150;

  function scrollToWidget() {
    if (ratingWidget) {
      // Calculate the top offset position of the widget
      let topOffset =
        ratingWidget.getBoundingClientRect().top +
        window.scrollY -
        headerHeight;

      // Perform the scroll
      window.scrollTo({
        top: topOffset,
        behavior: "smooth", // Smooth scrolling
      });
    }
  }

  // Add a delay to ensure elements are loaded
  setTimeout(function () {
    if (ratingStars.length > 0) {
      ratingStars.forEach((star) => {
        star.addEventListener("click", scrollToWidget);
      });
    }
  }, 1000);
});

/*
document.addEventListener('DOMContentLoaded', function() {
  // Function to adjust the height of the slider based on the selected slide
  function adjustSliderHeight() {
      const slider = document.querySelector('.shopify-section--timeline .timeline__slider');
      const selectedSlide = document.querySelector('.shopify-section--timeline .timeline__slide.is-selected');
      
      if (selectedSlide && slider) {
          // Set the height of the slider to the height of the active (selected) slide
          slider.style.height = selectedSlide.offsetHeight + 'px';
      }
  }
  
  // Initialize MutationObserver to watch for changes in the 'is-selected' class
  const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              adjustSliderHeight(); // Adjust height when the class changes
          }
      });
  });
  
  // Observe all the slides for changes in the 'class' attribute
  document.querySelectorAll('.shopify-section--timeline .timeline__slide').forEach(slide => {
      observer.observe(slide, { attributes: true });
  });
  
  // Initial call to set the correct height on page load
  adjustSliderHeight();

});
*/

setTimeout(() => {
  document.querySelectorAll(".ruk_rating_snippet").forEach((ratingSnippet) => {
    let reviewText = ratingSnippet.querySelector(".ruk-rating-snippet-count");
    if (reviewText && reviewText.textContent.includes("(0 Bewertungen)")) {
      ratingSnippet.closest("reviewsio-product-ratings").style.display = "none";
      console.log("Hiding review section with 0 reviews.");
    }
  });
}, 2000);


setTimeout(() => {
  document.querySelectorAll(".ruk_rating_snippet").forEach((ratingSnippet) => {
    let reviewText = ratingSnippet.querySelector(".ruk-rating-snippet-count");
    if (reviewText && reviewText.textContent.includes("(0 Bewertungen)")) {
      ratingSnippet.style.display = "none";
      console.log("Hiding only the rating snippet with 0 reviews.");
    }
  });
}, 2000);